export default {
  PhotoReview: {
    queued: { Text: 'Queued for review' },
    reviewed: { Text: 'Reviewed' },
  },
  PhotoRating: {
    pending: {
      Text: 'Pending Review',
      Description: 'Available to most users (those who have turned off Safe Browsing)',
    },
    public: {
      Text: 'Public',
      Description: 'Available to everyone',
    },
    'public-sensitive': {
      Text: 'Public',
      Description: 'Available to most users (those who have turned off Safe Browsing)',
    },
    banned: {
      Text: 'Banned content',
      Description: 'Marked for deletion',
    },
    private: {
      Text: 'Private',
      Description: 'Available only to users you authorized',
    },
    message: {
      Text: 'Message item',
      Description: 'For recipient only',
    },
    other: {
      Text: 'Unknown',
      Description: '',
    },
  },
  Community: {
    default: {
      TextField1: 'What I do',
      TextField2: 'Education',
      TextField3: 'Interests',
    },
    ferzu: {
      TextField1: 'My Fursona',
      TextField2: 'What I do / Education',
      TextField3: 'Interests',
    },
    pupspace: {
      TextField1: 'My hobbies',
      TextField2: 'My kinks and gear',
      TextField3: 'My boundaries, limits, and health info',
    },
  },
  CommunityCategories: {
    fandomsRoleplay: { Name: 'Fandoms and Roleplay' },
    plusSize: { Name: 'Plus-Size' },
    menInterestedInMen: { Name: 'Men Interested in Men' },
  },
  CommunityInfo: {
    headings: {
      about: 'About {{communityName}}',
      whatYouCanDo: 'What you can do on {{communityName}}',
      rules: 'Our Community Rules',
      welcome: 'Welcome to {{communityName}}',
    },
    communities: {
      grommr: {
        caption: 'Gainers & Encouragers (Gay)',
        description:
          'A gainer-encourager community for gay and bisexual men that celebrates body positivity, growth, inclusion, and acceptance.',
        sections: {
          about:
            'Grommr is proud to have served the gay and bisexual gainer-encourager community since 2011. The Grommr community brings together a diverse range of men from around the world who share one thing in common--a mentality that bigger is better.\n\nGrommr provides an inclusive forum for our community to connect, bond and thrive. We also coordinate regular local community meet ups (called GrommOffs) and organize larger semi-annual conferences, such as The Grom and EuroGrom.\n\nWe aren\'t the first network to serve the gainer-encourager community, which has been connecting since its early days in the 1980s. To learn more about the history of this awesome, body-positive community, check out <a href="https://www.grommr.com/Home/Community">The Gainer History Project</a>.',
          whatYouCanDo:
            ' • Browse the newsfeed, make posts, comment and join discussions.\n • Explore nearby profiles or search for members with similar interests.\n • Start chats with new contacts or old friends.\n • Share your photos or check out recent photos by other members.\n • Find out about gainer community events happening near you.',
          rules:
            'We strive to keep Grommr a welcoming home for all our members. Any illegal activity, trolling, harassment, racism, misogyny, homophobia, transphobia, ableism, fatphobia, and public displays of nudity or sexual acts are all strictly forbidden on Grommr.',
          welcome:
            'If there\'s anything our admin team can help you with, don\'t hesitate to open a support ticket or send us an e-mail.\n\nWelcome!\n\nThe Grommr Team',
        },
      },
      feabie: {
        caption: 'Feedism & BBW',
        description:
          'A feedism community for everyone that celebrates body positivity, growth, inclusion and acceptance.',
        sections: {
          about:
            'Feabie provides an inclusive environment where members of the feedism community--of all orientations--can connect, whether its for a chat, a date or a community event. We welcome feedists, fat admirers, BBW/BHM and anyone else who feels at home on Feabie.\n\nIn addition to our online community, Feabie also coordinates FeabieMeets--a series of local gatherings that bring together a diverse range of Feabie members to connect offline.\n\nFeabie is the largest social network serving the feedism community and one of the largest body-positive social networks in the world.',
          whatYouCanDo:
            ' • Browse the newsfeed, make posts, comment and join discussions.\n • Explore nearby profiles or search for members with similar interests.\n • Start a chat and set up a date, or just catch up with friends\n • Share your photos or check out recent photos by other members.\n • Find out about feedism community events happening near you.',
          rules:
            'Our admins work hard to keep Feabie as inclusive and welcoming as possible. Illegal activity, trolling, harassment, racism, misogyny, homophobia, transphobia, ableism, fatphobia, and public displays of nudity or sexual acts are all strictly forbidden on Feabie.',
          welcome:
            'Our admins are here to help! If you have a question or a concern, please don\'t hesitate to open a support ticket or send us an e-mail.\n\nWelcome!\n\nThe Feabie Team',
        },
      },
      chasabl: {
        caption: 'Bears, Chubs & Chasers (Gay)',
        description:
          'A chub-bear community for gay and bisexual men that celebrates body positivity, inclusion and acceptance.',
        sections: {
          about:
            'Chasable is proud to have served as the largest social network for the chub-bear community since 2013. Since then, Chasable has earned a reputation as a welcoming environment for gay and bisexual men of all sizes, shapes and colors. We welcome chubs, bears, chasers and anyone in between.\n\nWhile the chub-bear community is served by a number of "hook-up" and dating apps, no other app provides the kind of social features Chasable does. The Chasable newsfeed is a vital hub of discussion, photo sharing and support for the community.\n\nChasable regularly supports large chub-bear community events, such as Tidal Wave in Orlando and BGMO New York bar nights, and helps to promote chub-bear events worldwide.',
          whatYouCanDo:
            ' • Explore nearby guys or search for chubs, bears and chasers with similar interests.\n • Share your photos or check out recent photos by other members.\n • Browse the newsfeed, make posts, comment and join discussions.\n • Send a flirt, start a chat with a new guy, or catch up with friends.\n • Find out about chub-bear events happening near you.',
          rules:
            'Chasable admins help to keep our community a safe space for everyone. Illegal activity, trolling, harassment, racism, misogyny, homophobia, transphobia, ableism, fatphobia, and public displays of nudity or sexual acts are all strictly forbidden on Chasable.',
          welcome:
            'Have questions? See something that shouldn\'t be on Chasable? Our admin team is here to help! Open a support ticket at any time, or e-mail us.\n\nWelcome!\n\nThe Chasable Team',
        },
      },
      ferzu: {
        caption: 'Furries & Anthros',
        description:
          'A furry community for everyone that celebrates the furry fandom, furry artistry and inclusion.',
        sections: {
          about:
            'Ferzu is the largest social network dedicated to serving the furry fandom. Whether your fursona walks, flies or swims, whether you\'re straight or LGBTQ, chubby or thin, stripes or spots, you\'ll find an inclusive home on Ferzu.\n\nWe\'re proud to provide a safe space for all furries to connect and flourish. Oftentimes, discussions happen on Ferzu that would never happen on more troll-friendly mainstream social media.',
          whatYouCanDo:
            ' • Browse the newsfeed, make posts, comment and join discussions.\n • Check out the latest furry artwork and share your own.\n • Explore nearby profiles or search for furries with similar interests.\n • Start chats with new contacts or old friends.\n • Find out about furry conventions, see who\'s going and join the fun.',
          rules:
            'Ferzu is a safe space for all furries. As a result, trolling, harassment, racism, misogyny, homophobia, transphobia, ableism, and public displays of nudity or sexual acts are all strictly forbidden.\n\nWe also care deeply about the artists who form the backbone of our community. As a result, our admins enforce strict policies to protect furry artwork.',
          welcome:
            'Our admin team is always available to answer your questions or help you with any issues on Ferzu. If you need anything at all, don\'t hesitate to open a support ticket or send us an e-mail.\n\nA big furry welcome!\n\nThe Ferzu Team',
        },
      },
      pupspace: {
        caption: 'Human Pups & Handlers',
        description:
          'A new pup play community for human pups, handlers and anyone who loves getting into the pup headspace.',
        sections: {
          about:
            'Pupspace is the first social network and app dedicated to serving the puppy play community and our friends. Members of all genders, identities and backgrounds are welcome.\n\nWe strive to build an inclusive and nurturing community for all our members, no matter what you identify as, where you live or if you\'re taken or not. Pupspace is a safe place where members are free to explore, to be themselves, to get into the pup headspace and to unleash their inner pup.',
          whatYouCanDo:
            '• Browse the newsfeed, make posts, comment and join discussions with other pups and handlers.\n• Explore nearby profiles or search for pups with similar interests.\n• Start a chat, set up a play date, or just catch up with friends.\n• Share your photos or check out recent photos by other pups.\n• Find out about puppy events and moshes happening near you.',
          rules:
            'Pupspace admins work hard to keep our community as inclusive and welcoming as possible. Illegal activity, trolling, harassment, racism, misogyny, homophobia, transphobia, ableism, and public displays of nudity or sexual acts are all strictly forbidden on Pupspace.',
          welcome:
            'Our admins are here to help! If you have a question or a concern, please don\'t hesitate to open a support ticket or send us an e-mail.\n\nWelcome to your new home! *wags*\n\nThe Pupspace Team',
        },
      },
    },
  },
  communities: {
    myCommunities: 'My Communities',
  },
  PostType: {
    ChangedLocation: 'Changed their location to: {{text}}',
    ChangedNickname: 'Changed their username: {{text}}',
    ChangedRelStatus: 'Changed their relationship status',
    ChangedWeight: 'Changed their weight to {{newWeight}}, a gain of {{newWeightDiff}}',
    NewMember: 'Has joined {{communityName}}',
    NewPhoto: 'Has posted a new photo',
    NewEvent: 'Has posted a new event: ',
    NotifyNewComment: {
      post: 'commented on a post',
      photo: 'commented on a photo',
    },
    NotifyNewFollow: 'started following you',
    NotifyNewWallToWall: 'posted on your wall',
    NotifyPhotoLike: 'liked your photo',
    NotifyUnlocked: 'granted you access to their private photos',
    NotifyUnlockRequest: 'is requesting access to your private photos',
  },
  TransactionType: {
    Admin: 'Admin {{premium}} pass',
    Adjustment: 'Adjustment',
    BOGO: '{{premium}} Promotion (buy one, get one free)',
    Courtesy: 'Courtesy {{premium}} pass',
    DonationWithPaypal: 'Donation, thank you! (paid with PayPal)',
    FoundingMember: 'Founding member {{premium}} pass',
    GiftCertificatePaidFor: '{{premium}} Gift Certificate purchase',
    GiftCertificateRedeemed: '{{premium}} Gift Certificate redeemed',
    PaidByMail: '{{premium}} pass purchase (paid with cash/check/money order)',
    PaidWithApple: '{{premium}} subscription (paid with Apple App Store)',
    PaidWithCCBill: '{{premium}} subscription (paid with CCBill)',
    PaidWithGoogle: '{{premium}} subscription (paid with Google Play)',
    PaidWithPaypal: '{{premium}} pass purchase (paid with PayPal)',
    PaidWithStripe: '{{premium}} subscription (paid with Stripe)',
    Referrals: '{{premium}} time earned from referrals',
    Refund: 'Credit/Refund',
    Trial: 'Free {{premium}} Trial',
  },

  ProfileTags: {
    BodyFeatures: {
      Armpits: 'Armpits',
      ArmsLegs: 'Arms/legs',
      Asses: 'Asses',
      Athletic: 'Athletic',
      Average: 'Average',
      Balbo: 'Balbo',
      BallBelly: 'Ball-bellied',
      Beard: 'Beard',
      Beards: 'Beards',
      Bellies: 'Bellies',
      BellyButtons: 'Belly buttons/navels',
      BodyMods: 'Body modification',
      Breasts: 'Breasts (female)',
      BreastsFemale: 'Breasts (Female)',
      BreastsMale: 'Breasts (Male)',
      ChestPecs: 'Chest/pecs',
      ChinStrap: 'Chin strap',
      Chubby: 'Chubby all over',
      Chubby2: 'Chubby',
      ChubbyBelly: 'Chubby with a belly',
      ChunkyMuscle: 'Chunky muscle',
      Curvy: 'Curvy',
      Feet: 'Feet',
      First30: 'First 30 pounds',
      FullBeard: 'Full beard',
      Goatee: 'Goatee',
      Hairy: 'Hairy',
      Hands: 'Hands',
      Husky: 'Husky',
      LightBeard: 'Light beard',
      LoveHandles: 'Love handles',
      ManTits: 'Man tits',
      Moustache: 'Moustache',
      MuscleGut: 'Muscle and gut',
      Muscular: 'Muscular',
      MuttonChops: 'Mutton chops',
      Nipples: 'Nipples',
      None: 'None',
      PearChubby: 'Pear-shaped chubby',
      PencilThin: 'Pencil thin line',
      Piercings: 'Piercings',
      SlightlyChubby: 'Slightly chubby',
      Slim: 'Slim',
      Smooth: 'Smooth',
      SomeHair: 'Some hair',
      SuperChub: 'Super chub',
      SuperChubby: 'Super chubby',
      Tattoos2: 'Tattoos',
      ThickCurvy: 'Thick/curvy',
      Thin: 'Thin',
      Toned: 'Toned muscle',
      Trimmed: 'Trimmed',
      VanDyke: 'Van dyke',
      VeryChubby: 'Very chubby',
      VeryHairy: 'Very hairy',
    },
    Other: {
      AfterCare: 'After care',
      Agender: 'Agender',
      AgePlay: 'Age play',
      AnalPlayBottom: 'Anal (bottom)',
      AnalPlayTop: 'Anal (top)',
      Androgynous: 'Androgynous',
      Asexuality: 'Asexuality',
      Babyfur: 'DiaperFur',
      BalloonPlay: 'Balloon play',
      Bathing: 'Bathing/Showering',
      BDSM: 'BDSM',
      Belching: 'Belching',
      BellyPlay: 'Belly play',
      BellyRubs: 'Belly rubs',
      Biting: 'Biting',
      BitsGags: 'Bits/Gags',
      Bloating: 'Bloating',
      Blueberry: 'Blueberry',
      BodyOdors: 'Scent/Body odor',
      Bodypaint: 'Bodypaint',
      BodyWorship: 'Body worship',
      Bondage: 'Bondage/domination',
      Bondage2: 'Bondage',
      Boots: 'Boots',
      BootsHeels: 'Boots & high heels',
      BootsWorship: 'Boots/Boot worship',
      BowlEating: 'Eating from a bowl',
      Brats: 'Brats',
      BreastGrowth: 'Breast growth',
      BreathPlay: 'Breath play',
      Burping: 'Burping',
      Businessmen: 'Businessmen',
      ButtplugsDildos: 'Buttplugs/Dildos',
      CageSleep: 'Sleeping in a cage',
      CBT: 'CBT',
      Chastity: 'Chastity',
      Cigars: 'Cigars/pipes/tobacco',
      CollaredOwned: 'Collared/Owned',
      Complicated: "It's complicated",
      Control: 'Control',
      CrossDress: 'Cross-dressing',
      Cuckolding: 'Cuckolding',
      Cuddling: 'Cuddling/frottage',
      CunnGiver: 'Cunnilingus (giver)',
      CunnReceiver: 'Cunnilingus (receiver)',
      DaddySon: 'Daddy-son role play',
      Dating: 'Dating',
      DatingBreak: 'Taking a break from dating',
      Diapers: 'AB/DL',
      DirtyFur: 'Dirtyfur',
      DirtyTalking: 'Dirty talking',
      Discipline: 'Discipline/Punishments',
      DoctorPatient: 'Doctor-patient role play',
      Dogshow: 'Dogshow',
      Domination: 'Domination',
      DomSub: 'Dominance/submission',
      EdgePlay: 'Edge play',
      EdgingOrgasm: 'Edging/Orgasm control',
      Engaged: 'Engaged',
      EStim: 'Electro-stimulation',
      Exhibitionism: 'Exhibitionism/Public sex',
      ExplodBellies: 'Exploding bellies',
      FaceSitting: 'Face sitting',
      Farting: 'Farting',
      Feedee: 'Feedee',
      Feeder: 'Feeder',
      FeedingFeedee: 'Feeding (feedee)',
      FeedingFeeder: 'Feeding (feeder)',
      Female: 'Female',
      Feminine: 'Feminine',
      Fighting: 'Wrestling/Fighting',
      Fingering: 'Fingering',
      Fisting: 'Fisting',
      FistingBottom: 'Fisting (bottom)',
      FistingTop: 'Fisting (top)',
      Flogging: 'Flogging/Whips',
      FootWorship: 'Foot worship',
      ForceFeeding: 'Force feeding',
      Furries: 'Furries',
      Fursuit: 'Fursuit',
      Gaining: 'Gaining/encouraging',
      GainingInstant: 'Instant gaining',
      GainingLT: 'Long-term gaining',
      Gassy: 'Gassy',
      Genderfluid: 'Genderfluid',
      GenderNonconforming: 'Gender-Nonconforming',
      GenderShifting: 'Gender shifting',
      GroupSex: 'Group sex',
      GrowUnhealthy: 'Growing unhealthy',
      Gunge: 'Gunge',
      GutPunch: 'Gut punching',
      HandJob: 'Hand job',
      HandlerTrainer: 'Handler/Trainer',
      HandsfreeOrgasm: 'Hands-free orgasm',
      HeatEstrus: 'Heat/Estrus',
      Heels: 'Heels',
      Humiliation: 'Humiliation',
      Hypnosis: 'Hypnosis',
      Hypnotization: 'Hypnosis',
      Immobility: 'Gaining to immobility',
      Inflation: 'Inflation',
      Intersex: 'Intersex',
      InTraining: 'In training',
      KennelSleep: 'Sleeping in a basket/kennel',
      Kissing: 'Kissing',
      KnotPlay: 'Knot play/Tying',
      Latex: 'Latex',
      LeashWalk: 'Walk on leash',
      Leather: 'Leather',
      Licking: 'Licking',
      Lipstick: 'Fingernails & lipstick',
      Lycantropy: 'Lycanthropy',
      Lycra: 'Lycra',
      MacroMicro: 'Macro/micro fantasies',
      Male: 'Male',
      MalePreg: 'Mpreg (male pregnancy)',
      ManScent: 'Man-stink/body odor',
      Married: 'Married',
      Masculine: 'Masculine',
      Masochism: 'Masochism',
      Mature: 'Mature/older partners',
      Measuring: 'Measuring/weighing',
      Men: 'Men',
      MessyEat: 'Messy eating',
      MessyEating: 'Messy eating/pig play',
      MicroPenis: 'Micro penis',
      Military: 'Military',
      Monogamous: 'Monogamous',
      MpregBirthing: 'Mpreg/birthing',
      Murrsuit: 'Murrsuit',
      MuscleGrow: 'Muscle growth',
      MuscleWorship: 'Muscle worship',
      Musk: 'Musk',
      MutualMasturb: 'Mutual masturbation',
      Muzzles: 'Muzzles',
      Neoprene: 'Neoprene',
      NipplePlay: 'Nipple play',
      NonBinary: 'Non-binary',
      NonSexPupPlay: 'Non sexual pup play',
      Obedience: 'Obedience training/Commands',
      OlderMen: 'Mature/older men',
      OpenPolyRelation: 'In an open poly relationship',
      OpenRelationship: 'In an open relationship',
      OralBottom: 'Oral (bottom)',
      OralPlayBottom: 'Oral (giver)',
      OralPlayTop: 'Oral (receiver)',
      OralTop: 'Oral (top)',
      Other: 'Other',
      Oviposition: 'Oviposition',
      Owner: 'Owner',
      Pack: 'In a pack',
      Padding: 'Padding',
      Pegging: 'Pegging',
      Petting: 'Scratching/Petting',
      PigPlay: 'Pig play',
      PissPlay: 'Piss play/watersports',
      Plugtail: 'Plugtail',
      Plush: 'Plush',
      Polyamorous: 'Poly',
      PolyRelation: 'In a poly relationship',
      Pregnancy: 'Pregnancy',
      Primal: 'Primal',
      PublicSex: 'Public sex/voyeurism',
      Punks: 'Punks',
      PupGear: 'Pup gear',
      PupPlay: 'Pup play',
      PuppyGames: 'Puppy games (fetch, ballpit)',
      PuppyToys: 'Puppy toys',
      Queer: 'Queer',
      Relationship: 'In a relationship',
      Rimming: 'Rimming',
      RimmingGiver: 'Rimming (giver)',
      RimmingReceiver: 'Rimming (receiver)',
      RolePlay: 'Role play',
      Rubber: 'Rubber',
      RubberLatexLeather: 'Rubber/latex/leather',
      Sadism: 'Sadism',
      SadoMaso: 'Sadism/masochism',
      Saline: 'Saline',
      Scat: 'Scat',
      SciFiGain: 'Science-fiction gaining',
      Scratching: 'Scratching',
      SensoryDep: 'Sensory deprivation',
      SexualCanineRole: 'Sexual canine role',
      SheathPlay: 'Sheath-play',
      Single: 'Single',
      Skinheads: 'Skinheads',
      Smashing: 'Smashing/crushing',
      SmashingSitting: 'Smashing/sitting on someone',
      Sniffing: 'Sniffing',
      Sounding: 'Sounding/Catheters',
      Spanking: 'Spanking',
      SpeciesSpecific: 'Species-specific',
      Speedos: 'Speedos/lycra',
      Sportswear: 'Sportswear',
      Squashing: 'Squashing',
      StraightMen: 'Straight/married men',
      Stray: 'Stray',
      StretchMarks: 'Stretch marks',
      Stuffing: 'Stuffing',
      Submission: 'Submission',
      Suits: 'Suits',
      Swinging: 'Swinging & group sex',
      TailPulling: 'Tail-pulling',
      Tattoos: 'Tattoos/piercings',
      Teasing: 'Teasing',
      TeasingPublic: 'Teasing/public humiliation',
      Technophilia: 'Technophilia',
      Tentacles: 'Tentacles',
      Tickling: 'Tickling',
      TightClothes: 'Tight clothes/popping buttons',
      Toons: 'Toons',
      Toys: 'Toys/dildos',
      Trans: 'Transexuals/intersexuals',
      Transformation: 'Transformation',
      Transgender: 'Transgender',
      TransMan: 'Trans man',
      TransMen: 'Trans men',
      TransWoman: 'Trans woman',
      TransWomen: 'Trans women',
      Treats: 'Treats/Rewards',
      TwoSpirit: 'Two-Spirited',
      Uncle: 'Uncle/father/cousin fantasies',
      UncollaredUnowned: 'Uncollared/Unowned',
      UnderConsideration: 'Under consideration',
      Underwear: 'Underwear',
      Uniforms: 'Uniforms',
      VacantKennel: 'VacantKennel',
      VacBed: 'Vac bed/Sleep sacks',
      Vanilla: 'Vanilla/cuddles',
      VetRoleplay: 'Vet-pet roleplay',
      Vore: 'Vore',
      VoyeurExhib: 'Voyeurism & exhibitionism',
      Voyeurism: 'Voyeurism',
      WaterSports: 'Water sports',
      WaxPlay: 'Wax play',
      WeightGain: 'Weight gain',
      Wet: 'Wetlook/wetjeans',
      Widowed: 'Widowed',
      Women: 'Women',
      Wrestling: 'Wrestling/singlets',
    },
    SocialTags: {
      Admirer: 'Admirer',
      Alpha: 'Alpha',
      Amphibian: 'Amphibian',
      Aquatic: 'Aquatic',
      Avian: 'Avian',
      BBW: 'Big Beautiful Woman',
      Bear: 'Bear',
      BearSpecie: 'Bear',
      Beta: 'Beta',
      BHM: 'Big Handsome Man',
      Bloater: 'Bloater',
      Bovid: 'Bovid',
      Boy: 'Boy',
      Bull: 'Bull',
      Canid: 'Canid',
      Cervid: 'Cervid',
      CatKitten: 'Cat/Kitten',
      Chaser: 'Chaser',
      Chub: 'Chub',
      Chub4Chub: 'Chub4Chub',
      ChubbyBear: 'Chubby Bear',
      Cub: 'Cub',
      Daddy: 'Daddy',
      Dog: 'Dog',
      Dominant: 'Dom',
      Dragon: 'Dragon',
      Encourager: 'Encourager',
      Exotic: 'Exotic',
      FA: 'Fat Admirer',
      Feedee: 'Feedee',
      Feeder: 'Feeder',
      FelineLarge: 'Feline (large)',
      FelineSmall: 'Feline (small)',
      Fox: 'Fox',
      FriendOfPups: 'Friend of pups',
      Gainer: 'Gainer',
      HandlerTrainer: 'Handler/Trainer',
      Horse: 'Horse',
      HorsePony: 'Horse/Pony',
      Hybrid: 'Hybrid',
      Maintainer: 'Maintainer',
      Marsupial: 'Marsupial',
      Master: 'Master',
      Mistress: 'Mistress',
      Mommy: 'Mommy',
      MuscleGainer: 'Muscle Gainer',
      Omega: 'Omega',
      Otter: 'Otter',
      OtherMammal: 'Other (mammal)',
      OtherSpecie: 'Other',
      Panda: 'Panda',
      PetOther: 'Pet (Other)',
      Primate: 'Primate',
      Pup: 'Pup',
      Rabbit: 'Rabbit',
      Raccoon: 'Raccoon',
      Reptilian: 'Reptilian',
      Rodent: 'Rodent',
      Sir: 'Sir',
      Skunk: 'Skunk',
      Slave: 'Slave',
      Submissive: 'Sub',
      Switch: 'Switch',
      Wolf: 'Wolf',
    },
    Languages: {
      Arabic: 'Arabic',
      Bulgarian: 'Bulgarian',
      Chinese: 'Chinese',
      Czech: 'Czech',
      Danish: 'Danish',
      Dutch: 'Dutch',
      English: 'English',
      Filipino: 'Filipino',
      Finnish: 'Finnish',
      French: 'French',
      German: 'German',
      Greek: 'Greek',
      Hebrew: 'Hebrew',
      Hindi: 'Hindi',
      Hungarian: 'Hungarian',
      Indonesian: 'Indonesian',
      Italian: 'Italian',
      Japanese: 'Japanese',
      Korean: 'Korean',
      Norwegian: 'Norwegian',
      Others: 'Other(s)',
      Persian: 'Persian',
      Polish: 'Polish',
      Portuguese: 'Portuguese',
      Romanian: 'Romanian',
      Russian: 'Russian',
      SerboCroatian: 'Serbo-Croatian',
      Sign: 'Sign language',
      Slovak: 'Slovak',
      Spanish: 'Spanish',
      Swedish: 'Swedish',
      Thai: 'Thai',
      Turkish: 'Turkish',
      Ukranian: 'Ukrainian',
      Urdu: 'Urdu',
      Vietnamese: 'Vietnamese',
    },
    Interests: {
      AddPackMembers: 'Expand my pack',
      Alpha: 'Alpha',
      AsexualRelationship: 'Asexual relationship',
      BdsmDynamic: 'BDSM dynamic',
      Beta: 'Beta',
      Boy: 'Boy',
      Collaring: 'Collaring',
      Daddy: 'Daddy',
      Date: 'Date',
      Dominant: 'Dom',
      Exploration: 'Initiation/Exploration',
      FormPack: 'Form a new pack',
      Friends: 'Friends',
      Gaming: 'Gaming',
      HandlerTrainer: 'Handler/Trainer',
      Hookup: 'Casual encounter',
      JoinPack: 'Join an existing pack',
      Master: 'Master',
      Mistress: 'Mistress',
      Mommy: 'Mommy',
      Moshes: 'Pup moshes/events',
      NonSexualPlaymates: 'Non-sexual playmates',
      Omega: 'Omega',
      OnlineChat: 'Online chatting',
      OnlineVideo: 'Online video (cam2cam)',
      PolyRelation: 'Poly relationship',
      PolyRelationship: 'Poly relationship',
      Relationship: 'Relationship',
      RoleplayPartner: 'Roleplay partner',
      RomanticPartner: 'Romantic partner',
      Sex: 'Casual encounter',
      SexPartner: 'Regular intimate partner',
      Sir: 'Sir',
      Slave: 'Slave',
      Submissive: 'Sub',
      Switch: 'Switch',
      Training: 'Training',
      VideoChat: 'Video chat',
    },
    Ethnicities: {
      Arab: 'Middle Eastern/North African',
      Asian: 'East Asian',
      Black: 'Black/African Descent',
      Hispanic: 'Hispanic/Latinx',
      Mixed: 'Mixed/Multi',
      Native: 'Native American/Indigenous',
      Pacific: 'Pacific Islander',
      SouthAsian: 'South Asian',
      White: 'White/Caucasian',
    },
  },
};
